import { Button } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState, FC } from 'react';

interface HoverButtonProps {
  defaultIcon: string;
  hoverIcon: string;
  children: React.ReactNode;
  colorB?: string;
  link?: string;
  onClick?: () => void;
}

const AppbarButton: FC<HoverButtonProps> = ({ defaultIcon, hoverIcon, children, colorB, onClick, link }) => {
  const [isHovered, setIsHovered] = useState(false);
  const router = useRouter();
  const showHoverIcon = router.pathname === '/app/story/[id]';

  const isActive = link && router.pathname === link;

  const handleClick = () => {
    if (link) {
      router.push(link);
    }
    if (onClick) {
      onClick();
    }
  };
  const isStoryRoute = router.pathname === '/app/story/[id]' || router.pathname === '/app/story/[id]/memory/create';

  return (
    <Button
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: isActive ? '#0072CE' : 'transparent',

        color: isStoryRoute ? '#fff' : isActive ? 'white' : '#212d6d',
        border: isActive ? '3px solid #0072CE' : '3px solid transparent',
        borderRadius: '10px',
        transition: 'all 0.3s ease',
        '&:hover': {
          backgroundColor: '#0072CE',
          color: 'white',
          borderColor: '#0072CE',
        },
        '&:active': {
          backgroundColor: '#0072CE',
          color: 'white',
          borderColor: '#0072CE',
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}>
      <Image priority
        src={isStoryRoute || isHovered || isActive ? hoverIcon : defaultIcon}
        alt='button-icon'
        width={14}
        height={14}
      />
      {children}
    </Button>
  );
};

export default AppbarButton;
